import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../../lib/peApi";

const Ctx = createContext(null);

export function PEAuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  const refresh = useCallback(async () => {
    try {
      setUser(await api("/auth/me"));
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: if returning from the OAuth callback, skip the /me check —
    // AuthCallback exchanges the session_id and establishes the session first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(null);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api("/auth/logout", { method: "POST" }).catch(() => {});
    setUser(null);
  };

  return <Ctx.Provider value={{ user, setUser, refresh, logout }}>{children}</Ctx.Provider>;
}

export const usePEAuth = () => useContext(Ctx);
